import * as segmentAnalytics from '@segment/analytics.js-core';
import { gql, makeUserAnalyticsData } from '@yi/core';
import { MembershipTierWithAnon } from '@yi/core/src/types/MembershipTierWithAnon';

import { notifyBugsnag, analytics } from '~/common';
import { EVENT_NAMES } from '~/src/common/analytics/constants';
import { UserData, PageViewData } from '~/types';

interface Args {
  pageViewData?: PageViewData;
  currentUser: gql.typesClient.Query_CurrentUser_Base['CurrentUser'];
  tier: MembershipTierWithAnon | null;
}

// @TODO_POST_LAUNCH Fix types
declare global {
  interface Window {
    segmentData: UserData & PageViewData;
    analytics: typeof segmentAnalytics;
  }
}

export const sendPageView = ({ pageViewData = {}, currentUser, tier }: Args) => {
  try {
    // Clear possible data from previous pages but maintain user data
    if (window.segmentData) {
      window.segmentData.contentAuthor = undefined;
      window.segmentData.contentChannel = undefined;
      window.segmentData.contentTopic = undefined;
      window.segmentData.contentPubDate = undefined;
      window.segmentData.contentTitle = undefined;
      window.segmentData.contentId = undefined;
      window.segmentData.contentClassDuration = undefined;
      window.segmentData.contentClassStyle = undefined;
      window.segmentData.contentClassLevel = undefined;
      window.segmentData.courseAccessType = undefined;
    }

    // Push page and user data
    const userData = makeUserAnalyticsData(currentUser, tier);
    const simpleUserData =
      'userId' in userData
        ? {
            userId: userData.userId,
            memberType: userData.memberType,
            email: userData.email,
            firstName: userData.firstName,
            lastName: userData.lastName,
            phone: userData.phone,
            company: userData.company,
            company_slug: userData.company_slug,
          }
        : userData;
    Object.entries({ ...simpleUserData, ...pageViewData }).forEach(([key, val]) => {
      if (val) analytics.logAnalyticsData({ [key]: val });
    });

    analytics.setFacebookIds();

    // Push page view event
    analytics.logAnalyticsEvent(
      { event: EVENT_NAMES.GATSBY_PAGEVIEW },
      currentUser,
      tier || 'Anon',
    );
  } catch (e) {
    console.error(e);
    notifyBugsnag(e);
  }
};
